import { Link, Text, View } from "@react-pdf/renderer";

interface ReportingFileListProps {
	files: any[];
	buildUrl: (fileObj: any) => string | null;
}

function ReportingFileList({ files, buildUrl }: ReportingFileListProps) {
	return (
		<View style={{ flexDirection: "column", gap: 4 }}>
			{files.map((fileObj: any, idx: number) => {
				const href = buildUrl(fileObj);
				const displayName = fileObj?.name ?? "File";
				return (
					<View key={idx} style={{ flexDirection: "row" }}>
						<Text>{`${idx + 1}. `}</Text>
						{href ? (
							<Link src={href}>
								<Text>{displayName}</Text>
							</Link>
						) : (
							<Text>{displayName}</Text>
						)}
					</View>
				);
			})}
		</View>
	);
}

export default ReportingFileList;
